import React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { GoHoverTooltip } from '../../go-config/components/GoHoverTooltip';

export default function PermVisibilityEyeBtn({ label, visible, onClick, disabled = false, blockedTip = '' }) {
  const Icon = visible ? Eye : EyeOff;
  const tip = blockedTip || (visible ? 'Ocultar' : 'Exibir');
  return (
    <GoHoverTooltip text={tip} align="end" zIndex={13050}>
      <button
        type="button"
        className={`pct-card-eye${visible ? '' : ' is-off'}${blockedTip ? ' is-blocked' : ''}`}
        aria-label={blockedTip ? `${label}: ${blockedTip}` : `${visible ? 'Ocultar' : 'Exibir'} ${label}`}
        aria-pressed={visible}
        aria-disabled={blockedTip ? true : undefined}
        onClick={blockedTip ? undefined : onClick}
        disabled={disabled}
      >
        <Icon size={13} strokeWidth={2} aria-hidden />
      </button>
    </GoHoverTooltip>
  );
}
